var _excluded = ["children"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from 'react';
import { Transition } from 'react-transition-group';
import { jsx as ___EmotionJSX } from "@emotion/core";
var ENTER_DURATION = 350;
var EXIT_DURATION = 350;
var COLLAPSE_DURATION = 150;
var useStyles = () => {
  return React.useMemo(() => {
    return {
      root: {
        height: 'auto',
        overflow: 'hidden',
        transition: "width ".concat(ENTER_DURATION, "ms ease-in 0ms"),
        width: 0,
        '&.entered': {
          height: 'auto',
          overflow: 'visible',
          width: 'auto'
        },
        '&.exited': {
          visibility: 'hidden'
        }
      },
      wrapper: {
        display: 'flex',
        width: 'auto',
        height: '100%'
      },
      wrapperInner: {
        width: 'auto',
        height: '100%'
      }
    };
  }, []);
};
var GroupTransition = _ref => {
  var {
      children
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  var nodeRef = React.useRef(null);
  var wrapperRef = React.useRef(null);
  var styles = useStyles();
  var handleEnter = React.useCallback(() => {
    var node = nodeRef.current;
    if (!node || !wrapperRef.current) return;
    wrapperRef.current.style.position = 'absolute';
    node.style.width = '0px';
  }, [nodeRef, wrapperRef]);
  var handleEntering = React.useCallback(() => {
    var node = nodeRef.current;
    if (!node || !wrapperRef.current) return;
    var wrapperSize = wrapperRef.current.clientWidth || 0;
    wrapperRef.current.style.position = '';
    node.style.transitionDuration = "".concat(ENTER_DURATION, "ms");
    node.style.width = "".concat(wrapperSize, "px");
    node.style.transitionTimingFunction = 'ease-in';
  }, [nodeRef, wrapperRef]);
  var handleEntered = React.useCallback(() => {
    var node = nodeRef.current;
    if (!node || !wrapperRef.current) return;
    var wrapperSize = wrapperRef.current.clientWidth || 0;
    node.style.width = "".concat(wrapperSize, "px");
  }, [nodeRef, wrapperRef]);
  var handleExit = React.useCallback(() => {
    var node = nodeRef.current;
    if (!node || !wrapperRef.current) return;
    var wrapperSize = wrapperRef.current.clientWidth || 0;
    node.style.width = "".concat(wrapperSize, "px");
  }, [nodeRef, wrapperRef]);
  var handleExiting = React.useCallback(() => {
    var node = nodeRef.current;
    if (!node) return;
    node.style.transitionDuration = "".concat(EXIT_DURATION, "ms");
    node.style.width = '0px';
    node.style.transitionTimingFunction = 'ease-in';
  }, [nodeRef]);
  return ___EmotionJSX(Transition, _extends({
    nodeRef: nodeRef,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExiting: handleExiting,
    timeout: {
      enter: ENTER_DURATION,
      exit: EXIT_DURATION + COLLAPSE_DURATION
    }
  }, props), state => ___EmotionJSX("div", {
    css: styles.root,
    className: state,
    ref: nodeRef
  }, ___EmotionJSX("div", {
    css: styles.wrapper,
    ref: wrapperRef
  }, ___EmotionJSX("div", {
    css: styles.wrapperInner
  }, children))));
};
GroupTransition.displayName = 'GroupTransition';
export default GroupTransition;